import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { ApiInterceptor } from './ApiInterceptor';
import { AppRoutingModule } from './app-routing.module';
import { MainViewModule } from './main-view/main-view.module';
import { SpinnerModule } from './shared/spinner/spinner.module';
import { AdminViewModule } from './admin-view/admin-view.module';
import { MyMeetingsViewModule } from './my-meetings-view/my-meetings-view.module';
import { SupporterViewModule } from './supporter-view/supporter-view.module';
import { NavigationModule } from './navBar/navigation.module';
import { SchedulerNavigationModule } from './shared/kendo-scheduler-navigation/scheduler-navigation.module';
import { ConfirmationDeactivateModule } from './shared/ConfirmationDeactivateModule/confirmationdeactivate.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { SharedService } from './shared/shared.service';
import { NotificationBodyService } from './shared/notification-body/notification-body.service';
import { environment } from '../environments/environment';
import { PageNotFoundModule } from './page-not-found/page-not-found.module';
import { TranslationModule } from './shared/translation/translation.module';
import { TranslationService } from './shared/translation/translation.service';
import { NoDivisionErrorPageModule } from './no-division-error-page/no-division-error-page.module';
import { SecureStorageService } from './shared/secure-storage.service';
import {
  OKTA_CONFIG,
  OktaAuthModule
} from '@okta/okta-angular';
import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import { UserNotAssignedToApplicationErrorPageModule } from './user-not-assigned-to-application-error-page/user-not-assigned-to-application-error-page.module';

const storageProvider = {
  getItem: function (key) {
    return localStorage.getItem(key)
  },
  setItem: function (key, val) {
    return localStorage.setItem(key, val)
  }
}

const config = {
  clientId: environment.clientId,
  issuer: environment.issuer,
  redirectUri: environment.redirectUri,
  scopes: environment.scope,
  pkce: true,
  storageManager: {
    token: {
      storageProvider: storageProvider
    },
    cache: {
      storageProvider: storageProvider
    }
  },
  tokenManager: {
    storage: 'cookie',
  }
  }

const oktaAuth = new OktaAuth(config);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    OktaAuthModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    MainViewModule,
    AdminViewModule,
    SpinnerModule,
    DropDownsModule,
    NotificationModule,
    MyMeetingsViewModule,
    ReactiveFormsModule,
    SupporterViewModule,
    NavigationModule,
    SchedulerNavigationModule,
    ConfirmationDeactivateModule.forRoot(),
    PageNotFoundModule,
    TranslationModule,
    NoDivisionErrorPageModule,
    UserNotAssignedToApplicationErrorPageModule
  ],
  providers: [
        { provide: OKTA_CONFIG, useValue: { oktaAuth } },
        { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
        SharedService,
        NotificationBodyService,
        TranslationService,
        SecureStorageService,
        {
          provide: APP_INITIALIZER,
          useFactory: (ds: SecureStorageService) => () => ds.init(environment.storageEncryptKey),
          deps: [SecureStorageService],
          multi: true
        }      
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
